import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../environments/environment';

export const featureFlagsGuard: CanActivateFn = () =>
  environment.featureFlags || inject(Router).createUrlTree(['/settings']);
